import { useMutation, useQueryClient } from "@tanstack/react-query";
import { billingQueries } from "@/domains/billing/queries";
import { parseInsufficientCreditsError } from "@/domains/billing/errors";
import {
  createAnalysisFromTemplate,
  type CreateAnalysisFromTemplateInput,
} from "@/domains/templates/mutations";
import { reportQueries } from "../queries";

export function useCreateReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateAnalysisFromTemplateInput) =>
      createAnalysisFromTemplate(input),
    onSuccess: () => {
      void queryClient.invalidateQueries(reportQueries.lists());
    },
    onError: (error) => {
      if (parseInsufficientCreditsError(error)) {
        void queryClient.invalidateQueries(billingQueries.all);
      }
    },
  });
}
